// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa4b42b1","239":"ffa3c4b2","453":"d7177c50","455":"efdea635"}[chunkId] + ".chunk.js";
};